jQuery(document).ready(function($){

    $.each($(".tb-puffs, .tb-booking-puffs"), function() {
        var src = "";
        var container = $(this).find(".img-container");

        if($(this).width() > 400) {
            src = container.data("imgnormal");
            if(src === "") {
                src = container.data("imgsquare");
            }
        } else {
            src = container.data("imgsquare");
            if(src === "") {
                src = container.data("imgnormal");
            }
        }

        container.css({
            "background-image": "url('" + src + "')"
        })

    })

    $(".filter-wrp-old .filter-btn").each(function(){
        var data = $(this).attr('data-id');
        $(this).on("click", function() {
            $('.filter-wrp-old .filter-btn').removeClass('active');
            $(this).addClass('active');
            $('.puff-col').removeClass('active');
            $('.puff-col[data-id*=' + $(this).attr('data-id') + ']').addClass('active');
            if ($(this).data('id') == 'all-items') {
                $('.puff-col').addClass('active');
            }
        });
    });

});
